import React from 'react';
import PropTypes from 'prop-types';


const Spinner = ({ height, marginTop, marginRight, marginBottom, marginLeft }) => {
  const styles = {
    width: 'auto',
    height,
    marginTop,
    marginRight,
    marginBottom,
    marginLeft
  };
  return (
    <img src="/assets/img/spinner.gif" style={styles} />
  );
};

Spinner.propTypes = {
  height: PropTypes.string,
  marginTop: PropTypes.string,
  marginRight: PropTypes.string,
  marginBottom: PropTypes.string,
  marginLeft: PropTypes.string
};

Spinner.defaultProps = {
  height: '30px',
  marginTop: '0px',
  marginRight: '0px',
  marginBottom: '0px',
  marginLeft: '0px'
}

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/misc/Spinner.jsx